
import { defineComponent } from "vue";
import PageHeader from "@/components/ui/PageHeader.vue";

export default defineComponent({
  components: {
    PageHeader,
  },
});
